import apiRequest from './apiRequest';

type TokenType =
  | 'logout'
  | 'passwordLogin'
  | 'resetPassword'
  | 'verifyEmail'
  | 'deleteUser'
  | 'totp';

type ApiResponse = {
  location: string;
};

export default async function manageCartwheelSession(
  tokenType: TokenType,
  queryParams?: string | Record<string, string>,
) {
  const params = new URLSearchParams(queryParams);
  params.set('stytch_token_type', tokenType);

  return apiRequest<ApiResponse>('auth', `?${params.toString()}`);
}
